/*
This file is located in the main branch
Last time the file was updated (UTC): [11/7/2024 5:40:40AM]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useDictionaryWorkplaceState } from './Dictionary';

type DictionaryAddButtonProps = {
    showModal: () => void;
};

const DictionaryAddButton = ({ showModal }: DictionaryAddButtonProps) => {
    const { setSelectedItem: setCurrentItem, tableData } = useDictionaryWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={!tableData?.isUserEditable}
            title="BackOfficeAdd"
        />
    );
};

export default DictionaryAddButton;
